import { IndustryTemplate } from '@/components';
import { electricalContent } from '@/data/industries/electrical';

export function ElectricalPage() {
  return <IndustryTemplate content={electricalContent} />;
}
